import {
    take,
    put,
    call,
    all,
    takeEvery,
} from 'redux-saga/effects';
import { policiesActions as actions, notificationActions } from '../actions';
import { policiesService } from '../services';

/* Add Policy Category Sagas */
function* handleCreatePolicyCategoryRequest() {
    const action = yield take(actions.createPolicyCategoryRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.createPolicyCategory, dataParams);
        if (res.isError) {
            yield put(actions.createPolicyCategoryError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.createPolicyCategorySuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.createPolicyCategoryError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get All Policy Category Sagas */
function* handleGetAllPolicyCategorysRequest() {
    const action = yield take(actions.getAllPolicyCategorysRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.getAllPolicyCategorys, dataParams);
        if (res.isError) {
            yield put(actions.getAllPolicyCategorysError(res));
        } else {
            yield put(actions.getAllPolicyCategorysSuccess(res));
        }
    } catch (error) {
        yield put(actions.getAllPolicyCategorysError());
    }
}

/* Update Policy Category Sagas */
function* handleUpdatePolicyCategoryRequest() {
    const action = yield take(actions.updatePolicyCategoryRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.updatePolicyCategory, dataParams);
        if (res.isError) {
            yield put(actions.updatePolicyCategoryError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updatePolicyCategorySuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updatePolicyCategoryError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Delete Policy Category Sagas */
function* handleDeletePolicyCategoryRequest() {
    const action = yield take(actions.deletePolicyCategoryRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.deletePolicyCategory, dataParams);
        if (res.isError) {
            yield put(actions.deletePolicyCategoryError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deletePolicyCategorySuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deletePolicyCategoryError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Create Policy Sagas*/
function* handleCreatePolicyRequest() {
    const action = yield take(actions.createPolicyRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.createPolicy, dataParams);
        if (res.isError) {
            yield put(actions.createPolicyError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.createPolicySuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.createPolicyError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get All Policy Sagas */
function* handleGetAllPolicyRequest() {
    const action = yield take(actions.getAllPolicyRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.getAllPolicy, dataParams);
        if (res.isError) {
            yield put(actions.getAllPolicyError(res));
        } else {
            yield put(actions.getAllPolicySuccess(res));
        }
    } catch (error) {
        yield put(actions.getAllPolicyError());
    }
}

/* Get Policy By Category Id Saga  */
function* handlegetPolicyByCategoryIdRequest() {
    const action = yield take(actions.getPolicyByCategoryIdRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.getPolicyByCategoryId, dataParams);
        if (res.isError) {
            yield put(actions.getPolicyByCategoryIdError(res));
        } else {
            yield put(actions.getPolicyByCategoryIdSuccess(res));
        }
    } catch (error) {
        yield put(actions.getPolicyByCategoryIdError());
    }
}

/* Update Policy Sagas */
function* handleUpdatePolicyRequest() {
    const action = yield take(actions.updatePolicyRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.updatePolicy, dataParams);
        if (res.isError) {
            yield put(actions.updatePolicyError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updatePolicySuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updatePolicyError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}


/* Delete Policy Saga */
function* handleDeletePolicyRequest() {
    const action = yield take(actions.deletePolicyRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.deletePolicy, dataParams);
        if (res.isError) {
            yield put(actions.deletePolicyError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deletePolicySuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deletePolicyError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}



/* Accept Policy By User Sagas */
function* handleAcceptPolicyByUserRequest() {
    const action = yield take(actions.acceptPolicyByUserRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.acceptPolicyByUser, dataParams);
        if (res.isError) {
            yield put(actions.acceptPolicyByUserError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.acceptPolicyByUserSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.acceptPolicyByUserError());
    }
}

/* Get Policy Category List Sagas */
function* handleGetPolicyCategoryListRequest() {
    const action = yield take(actions.getPolicyCategoryListRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.getPolicyCategoryList, dataParams);
        if (res.isError) {
            yield put(actions.getPolicyCategoryListError(res));
        } else {
            yield put(actions.getPolicyCategoryListSuccess(res));
        }
    } catch (error) {
        yield put(actions.getPolicyCategoryListError());
    }
}

/* Get Policy List Sagas */
function* handleGetPolicyListRequest() {
    const action = yield take(actions.getPolicyListRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.getPolicyList, dataParams);
        if (res.isError) {
            yield put(actions.getPolicyListError(res));
        } else {
            yield put(actions.getPolicyListSuccess(res));
        }
    } catch (error) {
        yield put(actions.getPolicyListError());
    }
}


/* Get Policy List Sagas */
function* handleGetClientTermsAndConditionsRequest() {
    const action = yield take(actions.getClientTermsAndConditionsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.getClientTermsAndConditions, dataParams);
        if (res.isError) {
            yield put(actions.getClientTermsAndConditionsError(res));
        } else {
            yield put(actions.getClientTermsAndConditionsSuccess(res));
        }
    } catch (error) {
        yield put(actions.getClientTermsAndConditionsError());
    }
}

/* Get Policy List Sagas */
function* handleSendOtpVerificationRequest() {
    const action = yield take(actions.sendOtpVerificationRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.sendOtpVerification, dataParams);
        if (res.isError) {
            yield put(actions.sendOtpVerificationError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.sendOtpVerificationSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.sendOtpVerificationError());
        yield put(notificationActions.openSnackbar({ text: error?.message || error?.errorMessage, alertType: 'error' }));
    }
}


/* Get Policy List Sagas */
function* handleVerifyClientTermsOTPRequest() {
    const action = yield take(actions.verifyClientTermsOTPRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.verifyClientTermsOTP, dataParams);
        if (res.isError) {
            yield put(actions.verifyClientTermsOTPError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.verifyClientTermsOTPSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.verifyClientTermsOTPError());
        yield put(notificationActions.openSnackbar({ text: error?.message || error?.errorMessage, alertType: 'error' }));
    }
}

/* Get Policy List Sagas */
function* handleAcceptAndRejectClientTermsRequest() {
    const action = yield take(actions.acceptAndRejectClientTermsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(policiesService.acceptAndRejectClientTerms, dataParams);
        if (res.isError) {
            yield put(actions.acceptAndRejectClientTermsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.acceptAndRejectClientTermsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.acceptAndRejectClientTermsError());
        yield put(notificationActions.openSnackbar({ text: error?.message || error?.errorMessage, alertType: 'error' }));
    }
}

// -----------Watchers-------------
function* handleCreatePolicyCategoryWatcher() {
    yield takeEvery(
        actions.createPolicyCategoryRequest,
        handleCreatePolicyCategoryRequest,
    );
}

function* handleGetAllPolicyCategorysWatcher() {
    yield takeEvery(
        actions.getAllPolicyCategorysRequest,
        handleGetAllPolicyCategorysRequest,
    );
}

function* handleUpdatePolicyCategoryWatcher() {
    yield takeEvery(
        actions.updatePolicyCategoryRequest,
        handleUpdatePolicyCategoryRequest,
    );
}

function* handleDeletePolicyCategoryWatcher() {
    yield takeEvery(
        actions.deletePolicyCategoryRequest,
        handleDeletePolicyCategoryRequest,
    );
}

function* handleCreatePolicyWatcher() {
    yield takeEvery(
        actions.createPolicyRequest,
        handleCreatePolicyRequest,
    );
}

function* handleGetAllPolicyWatcher() {
    yield takeEvery(
        actions.getAllPolicyRequest,
        handleGetAllPolicyRequest,
    );
}

function* handlegetPolicyByCategoryIdWatcher() {
    yield takeEvery(
        actions.getPolicyByCategoryIdRequest,
        handlegetPolicyByCategoryIdRequest,
    );
}

function* handleUpdatePolicyWatcher() {
    yield takeEvery(
        actions.updatePolicyRequest,
        handleUpdatePolicyRequest,
    );
}

function* handleDeletePolicyWatcher() {
    yield takeEvery(
        actions.deletePolicyRequest,
        handleDeletePolicyRequest,
    );
}

function* handleAcceptPolicyByUserWatcher() {
    yield takeEvery(
        actions.acceptPolicyByUserRequest,
        handleAcceptPolicyByUserRequest,
    );
}

function* handleGetPolicyCategoryListWatcher() {
    yield takeEvery(
        actions.getPolicyCategoryListRequest,
        handleGetPolicyCategoryListRequest,
    );
}

function* handleGetPolicyListWatcher() {
    yield takeEvery(
        actions.getPolicyListRequest,
        handleGetPolicyListRequest,
    );
}


function* handleGetClientTermsAndConditionsWatcher() {
    yield takeEvery(
        actions.getClientTermsAndConditionsRequest,
        handleGetClientTermsAndConditionsRequest,
    );
}

function* handleSendOtpVerificationWatcher() {
    yield takeEvery(
        actions.sendOtpVerificationRequest,
        handleSendOtpVerificationRequest,
    );
}


function* handleVerifyClientTermsOTPWatcher() {
    yield takeEvery(
        actions.verifyClientTermsOTPRequest,
        handleVerifyClientTermsOTPRequest,
    );
}


function* handleAcceptAndRejectClientTermsWatcher() {
    yield takeEvery(
        actions.acceptAndRejectClientTermsRequest,
        handleAcceptAndRejectClientTermsRequest,
    );
}   


function* rootPoliciesSaga() {
    yield all([
        handleCreatePolicyCategoryRequest(),
        handleCreatePolicyCategoryWatcher(),

        handleGetAllPolicyCategorysRequest(),
        handleGetAllPolicyCategorysWatcher(),

        handleUpdatePolicyCategoryRequest(),
        handleUpdatePolicyCategoryWatcher(),

        handleDeletePolicyCategoryRequest(),
        handleDeletePolicyCategoryWatcher(),

        handleCreatePolicyRequest(),
        handleCreatePolicyWatcher(),

        handleGetAllPolicyRequest(),
        handleGetAllPolicyWatcher(),

        handlegetPolicyByCategoryIdRequest(),
        handlegetPolicyByCategoryIdWatcher(),

        handleUpdatePolicyRequest(),
        handleUpdatePolicyWatcher(),

        handleDeletePolicyRequest(),
        handleDeletePolicyWatcher(),

        handleAcceptPolicyByUserRequest(),
        handleAcceptPolicyByUserWatcher(),

        handleGetPolicyCategoryListRequest(),
        handleGetPolicyCategoryListWatcher(),

        handleGetPolicyListRequest(),
        handleGetPolicyListWatcher(),

        handleGetClientTermsAndConditionsRequest(),
        handleGetClientTermsAndConditionsWatcher(),

        handleSendOtpVerificationRequest(),
        handleSendOtpVerificationWatcher(),

        handleVerifyClientTermsOTPRequest(),
        handleVerifyClientTermsOTPWatcher(),

        handleAcceptAndRejectClientTermsRequest(),
        handleAcceptAndRejectClientTermsWatcher(),
    ]);
}

export default rootPoliciesSaga;
